import React, { createContext, useContext, useEffect, useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {jwtDecode} from 'jwt-decode'
import {setAccessToken} from '../utils/authFetch'
import { baseUrl } from '../utils/requestUrl';

const AuthContext = createContext();
export const AuthProvider = ({children}) => {
    const [token, setToken] = useState(localStorage.getItem('accessToken' || ''))
    const queryClient =  useQueryClient();

    const loginMutation = useMutation({ mutationFn: async(credentials) => {
        const response =  await fetch(`${baseUrl}/auth/login`, {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify(credentials)
        });
        const data =  await response.json();
        return data;
    },
        onSuccess: (data) => {
            
            if(data.data){
                const {access_token, refresh_token } = data.data;
                setAccessToken(access_token);
                localStorage.setItem('accessToken', access_token);
                localStorage.setItem('refreshToken', refresh_token);
                
                setToken(access_token);
                const userInfo = jwtDecode(access_token);
                localStorage.setItem('user',JSON.stringify(userInfo))
            }
        },
        onError: (error) => {
            console.error('Login failed', error)
        }
    })
    const updateToken = (newToken) => {
        setAccessToken(newToken);
        localStorage.setItem('accessToken', newToken);
        setToken(newToken);
        const userInfo = jwtDecode(newToken);
        localStorage.setItem('user', JSON.stringify(userInfo));
    }

    const logout = () => {
        setAccessToken(null);
        // Preserve profileComplete flags — they must survive logout so the
        // login flow can still gate incomplete-profile users on re-login
        const preserved = {};
        for (const key of Object.keys(localStorage)) {
            if (key.startsWith('profileComplete_')) {
                preserved[key] = localStorage.getItem(key);
            }
        }
        localStorage.clear();
        Object.entries(preserved).forEach(([key, value]) => localStorage.setItem(key, value));
        setToken(null);

        queryClient.clear();
        window.location.href = '/user/login';
    }

    // const refreshAccessTokenMutation = useMutation({mutationFn: async() => {
    //     const accessToken  = localStorage.getItem('accessToken');
    //     const response = await fetch (`${baseUrl}/auth/refresh_token`,{
    //         method:'POST',
    //         headers: {'Content-Type':'application/json', 'Authorization':`Bearer: ${accessToken}`},
    //         body: JSON.stringify({refreshToken}),
    //     });
    //     const data = await response.json();
    //     return data;
    // },
    //     onSuccess: (data) => {
    //         localStorage.setItem('accessToken', data.accessToken);
    //         setAccessToken(data.accessToken);
    //     }, 
    //     onError: (error) => {
    //         console.error('Failed to refresh token', error)
    //         logout()
    //     }
    // })
    // useEffect(()=>{
    //     const interval = setInterval(()=>{
    //         if(refreshToken){
    //             refreshAccessTokenMutation.mutate();
    //         }
    //     },30*59*1000)
    //     return () => clearInterval(interval);
    // }, [refreshToken])
  return (
    <AuthContext.Provider value={{accessToken:token, login: loginMutation, logout, updateToken}}>{children}</AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
